import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LibOverlayComponent } from './lib-overlay.component';

@NgModule({
  declarations: [LibOverlayComponent],
  imports: [CommonModule],
  exports: [LibOverlayComponent],
})
export class LibOverlayModule {}
